import styled from 'styled-components'
import { motion } from 'framer-motion'
import React from 'react'

type GridType = {
  children: any,
  maxWidth: number,
  fit?: boolean,
  gap?: number
}

const Grid = ({ 
  children, 
  maxWidth, 
  fit, 
  gap 
}: GridType) => (
  <S_Grid 
    maxWidth={maxWidth} 
    fit={fit} 
    gap={gap ? gap : 8}
    variants={{
      hidden: { opacity: 1, scale: 0 },
      visible: {
        opacity: 1,
        scale: 1,
        transition: { delayChildren: 0.12, staggerChildren: 0.12 }
      }
    }}
    initial='hidden'
    animate='visible'
  >
    {
      children.map((child, index) =>
        <S_Item 
          key={index} 
          variants={{
            hidden: { y: 20, opacity: 0 },
            visible: { y: 0, opacity: 1 }
          }} 
        >
          {
            child
          }
        </S_Item>
      )
    }
  </S_Grid>
)


export default Grid

const S_Grid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(310px, 1fr));
  grid-gap: 1rem;
  padding: 1rem;
`

const S_Item = styled(motion.div)`
`